// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\na[data-v-01010826] {\n  text-decoration: none;\n  color: inherit\n}\n.menu[data-v-01010826] {\n  margin-top: 50px;\n  display: grid;\n  grid-row-gap: 3em;\n}\nli[data-v-01010826] {\n  list-style: none;\n}\n.menu-item[data-v-01010826] {\n  list-style: none;\n  display: grid;\n  grid-template-columns:  1fr 6fr 1fr;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-size: 1.25em;\n}\n.right-arrow[data-v-01010826] {\n  color: lightgrey\n}", ""]);
// Exports
module.exports = exports;
